export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12846.f6a472ee.jpg";